import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import './Button.scss';

interface ButtonProps {
  className?: string,
  title: string,
  style?: any,
  logo?: any,
  loading?: boolean,
  isLogin?: boolean,
  disabled?: boolean,
  onClick?: () => any;
}

const Button = (props: ButtonProps) => {
  return (
    <div
      className={classNames(props.className, 'button' + (props.loading ? ' loading' : '') + (props.isLogin ? ' login' : ''))}
      style={{...props.style, opacity: props.disabled ? .5 : 1}}
      onClick={() => {
        if (!props.loading && !props.disabled && props.onClick) props.onClick();
      }}>
      {!props.loading && props.logo && (
        <FontAwesomeIcon icon={props.logo} />
      )}
      {props.loading ? '' : props.title}
    </div>
  );
};

export default Button

